// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 2/7/2024 12:30:23 PM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { ValidationScopeTypeEnum } from '../schema/Schema';
import { CompanyStatusTypeEnum } from '../schema/Schema';
import { CompanyTypeEnum } from '../schema/Schema';
import { NoteTypeEnum } from '../schema/Schema';
import { LocationTypeEnum } from '../schema/Schema';
import { LocationStatusTypeEnum } from '../schema/Schema';
import { CountryTypeEnum } from '../schema/Schema';
import { InvitationStatusTypeEnum } from '../schema/Schema';
import { SecurityRoleTypeEnum } from '../schema/Schema';

export enum GetCompanyEnum {
  companyNotFound = 0,
  invalidCorrelationKey = 1,
  invalidFilter = 2,
}

export enum PersistCompanyEnum {
  invalidCompanyTypeId = 0,
  companyIsNull = 1,
  invalidCompany = 2,
  multiplePrimaryLocation = 3,
  cannotSignupNewCompany = 4,
}

export enum GetCompanyListEnum {
  nameStartsWithIsEmpty = 0,
  takeIsGreaterThanHundred = 1,
  idListEmpty = 2,
  companyStatusEmpty = 3,
  invalidCompanyTypeId = 4,
  takeIsZero = 5,
  idListContainsMoreThanHundredId = 6,
}

export enum PersistNoteEmum {
  noteIsNull = 0,
  invalidCompanyId = 1,
}

export enum PersistLocationEnum {
  locationIsNull = 0,
  invalidLocation = 1,
  invalidCompanyId = 2,
  employeeCountNotZero = 3,
}

export enum GetLocationListEnum {}

export enum GetStateListEnum {}

export enum GetDepartmentListEnum {
  invalidCompanyId = 0,
}

export enum GetAssociatedCompanyListEnum {
  nameContainsIsEmpty = 0,
}

export enum GetNoteListEnum {
  invalidCompanyId = 0,
}

export enum RemoveNoteEnum {
  invalidNoteId = 0,
  invalidAuthorId = 1,
}

export enum PersistAssociatedCompanyEnum {
  companyNameNull = 0,
}

export enum RemindToAcceptInvitationEnum {
  invalidCompanyId = 0,
}

export interface GetCompanyRequestInterface {
  id: number;
  getById: boolean;
  includeEmployeeCounts: boolean;
  getByCompanyCode: boolean;
  companyCode: string;
  getByEmail: boolean;
  email: string;
  getByName: boolean;
  companyName: string;
  isPartner: boolean;
}

export interface GetCompanyResponseInterface {
  company: CompanyInterface;
  validationResults: ValidationResultsInterface;
}

export interface PersistCompanyRequestInterface {
  correlationKey?: string;
  validationScopeType: ValidationScopeTypeEnum;
  company: CompanyInterface;
}

export interface PersistCompanyResponseInterface {
  id: number;
  companyStatusType: CompanyStatusTypeEnum;
  validationResults: ValidationResultsInterface;
}

export interface GetCompanyListRequestInterface {
  companyType: CompanyTypeEnum;
  nameStartsWith: string;
  getByName: boolean;
  skip: number;
  take: number;
  getByIdList: boolean;
  idList: Array<number>;
  getByCompanyStatusType: boolean;
  companyStatusType: CompanyStatusTypeEnum;
  getTotalCount: boolean;
  includeSummaryOnly: boolean;
}

export interface GetCompanyListResponseInterface {
  totalCount: number;
  companySummaryList: Array<CompanySummaryInterface>;
  companyList: Array<CompanyInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PersistNoteRequestInterface {
  companyId: number;
  note: NoteInterface;
}

export interface PersistNoteResponseInterface {
  id: number;
  validationResults: ValidationResultsInterface;
}

export interface CompanyInterface {
  id: number;
  companyType: CompanyTypeEnum;
  primaryContactId?: number;
  companyStatusType: CompanyStatusTypeEnum;
  accountExecutivePersonId?: number;
  name: string;
  dba: string;
  description: string;
  email: string;
  createdDate: string;
  updatedDate?: string;
  companyCode: string;
  logoId: number;
  craNumber: string;
  feinNumber: string;
  twoStepApproval: boolean;
  jurisdictionId?: number;
  registrationNumber: string;
  jurisdiction: string;
  accountOwnerPersonId?: number;
  locationList: Array<LocationInterface>;
}

export interface NoteInterface {
  id: number;
  content: string;
  noteType: NoteTypeEnum;
  title: string;
  authorId: number;
  createdDate: string;
  authorName: string;
  actionExpiryDate: string;
}

export interface PersistLocationRequestInterface {
  companyId: number;
  location: LocationInterface;
}

export interface PersistLocationResponseInterface {
  id: number;
  validationResults: ValidationResultsInterface;
}

export interface GetLocationListRequestInterface {
  skip: number;
  take: number;
  getByIdList: boolean;
  idList: Array<number>;
  getTotalCount: boolean;
  companyId: number;
  getByName: boolean;
  nameContains: string;
  includeDisabledLocation: boolean;
}

export interface GetLocationListResponseInterface {
  totalCount: number;
  locationList: Array<LocationInterface>;
  validationResults: ValidationResultsInterface;
}

export interface LocationInterface {
  id: number;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  postal: string;
  locationType: LocationTypeEnum;
  name: string;
  isPrimary: boolean;
  employeeCount: number;
  locationStatusType: LocationStatusTypeEnum;
  stateId?: number;
  countryId: number;
  phoneNumber: string;
  companyId: number;
  remoteEmployeeCount: number;
}

export interface GetStateListRequestInterface {
  countryType: CountryTypeEnum;
  overrideHiddenStateList?: Array<number>;
}

export interface GetStateListResponseInterface {
  stateList: Array<StateInterface>;
  validationResults: ValidationResultsInterface;
}

export interface StateInterface {
  id: number;
  name: string;
  countryType: CountryTypeEnum;
  shortName: string;
}

export interface AssociatedCompanyInterface {
  id: number;
  name: string;
  companyStatusType: CompanyStatusTypeEnum;
  logoId?: number;
  countryId: number;
  ownerName: string;
  companyCode: string;
  email: string;
  isOnboardingCompleted: boolean;
  companyInvitation: CompanyInvitationInterface;
}

export interface CompanySummaryInterface {
  id: number;
  companyCode: string;
  name: string;
}

export interface CompanyInvitationInterface {
  id: number;
  senderCompanyId: number;
  receiverCompanyId: number;
  date: string;
  invitedByEmail: boolean;
  invitedByCompanyId: boolean;
  invitationStatusType: InvitationStatusTypeEnum;
  peopleCount: number;
  isInvitedByFirm: boolean;
  securityRoleType: SecurityRoleTypeEnum;
  associatedCompany: AssociatedCompanyInterface;
}

export interface GetDepartmentListRequestInterface {
  companyId: number;
  stateIdList: Array<number>;
  includeDisabled: boolean;
}

export interface GetDepartmentListResponseInterface {
  departmentList: Array<DepartmentInterface>;
  validationResults: ValidationResultsInterface;
}

export interface DepartmentInterface {
  id: number;
  name: string;
  companyId: number;
  hasManager: boolean;
}

export interface GetAssociatedCompanyListRequestInterface {
  getByName: boolean;
  nameContains: string;
}

export interface GetAssociatedCompanyListResponseInterface {
  associatedCompanyList: Array<AssociatedCompanyInterface>;
  validationResults: ValidationResultsInterface;
}

export interface RemoveNoteRequestInterface {
  noteId: number;
}

export interface RemoveNoteResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetNoteListRequestInterface {
  companyId: number;
}

export interface GetNoteListResponseInterface {
  noteList: Array<NoteInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PersistAssociatedCompanyRequestInterface {
  companyName: string;
  country: CountryTypeEnum;
  craNumber: string;
  feinNumber: string;
}

export interface PersistAssociatedCompanyResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface RemindToAcceptInvitationRequestInterface {
  partnerCompanyId: number;
  clientCompanyId?: number;
  clientEmailAddress: string;
  invitationId?: number; //Making this to optional, because if invitation is true then only need to add inivitationId
}

export interface RemindToAcceptInvitationResponseInterface {
  validationResults: ValidationResultsInterface;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../../../httpClient';

export class CompanyAccessService {
  getCompany(request: GetCompanyRequestInterface): Promise<GetCompanyResponseInterface> {
    return Post('/AppCoreCompanyAccess/getCompany', request);
  }

  persistCompany(request: PersistCompanyRequestInterface): Promise<PersistCompanyResponseInterface> {
    return Post('/AppCoreCompanyAccess/persistCompany', request);
  }

  getCompanyList(request: GetCompanyListRequestInterface): Promise<GetCompanyListResponseInterface> {
    return Post('/AppCoreCompanyAccess/getCompanyList', request);
  }

  persistNote(request: PersistNoteRequestInterface): Promise<PersistNoteResponseInterface> {
    return Post('/AppCoreCompanyAccess/persistNote', request);
  }

  persistLocation(request: PersistLocationRequestInterface): Promise<PersistLocationResponseInterface> {
    return Post('/AppCoreCompanyAccess/persistLocation', request);
  }

  getLocationList(request: GetLocationListRequestInterface): Promise<GetLocationListResponseInterface> {
    return Post('/AppCoreCompanyAccess/getLocationList', request);
  }

  getStateList(request: GetStateListRequestInterface): Promise<GetStateListResponseInterface> {
    return Post('/AppCoreCompanyAccess/getStateList', request);
  }

  getDepartmentList(request: GetDepartmentListRequestInterface): Promise<GetDepartmentListResponseInterface> {
    return Post('/AppCoreCompanyAccess/getDepartmentList', request);
  }

  getAssociatedCompanyList(
    request: GetAssociatedCompanyListRequestInterface
  ): Promise<GetAssociatedCompanyListResponseInterface> {
    return Post('/AppCoreCompanyAccess/getAssociatedCompanyList', request);
  }

  removeNote(request: RemoveNoteRequestInterface): Promise<RemoveNoteResponseInterface> {
    return Post('/AppCoreCompanyAccess/removeNote', request);
  }

  getNoteList(request: GetNoteListRequestInterface): Promise<GetNoteListResponseInterface> {
    return Post('/AppCoreCompanyAccess/getNoteList', request);
  }

  persistAssociatedCompany(
    request: PersistAssociatedCompanyRequestInterface
  ): Promise<PersistAssociatedCompanyResponseInterface> {
    return Post('/AppCoreCompanyAccess/persistAssociatedCompany', request);
  }

  remindToAcceptInvitation(
    request: RemindToAcceptInvitationRequestInterface
  ): Promise<RemindToAcceptInvitationResponseInterface> {
    return Post('/AppCoreCompanyAccess/remindToAcceptInvitation', request);
  }
}

export default new CompanyAccessService();
